import React from 'react';
import { Box } from '@mui/material';
import PhotosSegmentedControl, { PhotosSegmentOption } from './PhotosSegmentedControl';

interface MPhotoSectionTabsProps<T extends string> {
  value: T;
  onChange: (value: T) => void;
  options: PhotosSegmentOption<T>[];
  accentColor?: string;
  size?: 'sm' | 'md' | 'lg';
  /** Dính dưới navbar + tab Profile/Pro khi scroll (mobile) */
  sticky?: boolean;
  /** top sticky — mặc định dưới hàng tab UserDetail mobile */
  stickyTop?: number | Record<string, number | string>;
}

/** Tab pill một hàng ngang — dùng chung Lite / Mono / Pro */
function MPhotoSectionTabs<T extends string>({
  value,
  onChange,
  options,
  accentColor = '#0f3460',
  size = 'md',
  sticky = false,
  // Navbar 56/64 + hàng Profile/Pro (~60px)
  stickyTop = { xs: 116, sm: 124 },
}: MPhotoSectionTabsProps<T>) {
  return (
    <Box
      sx={{
        width: '100%',
        mb: { xs: 1, md: 2.5 },
        ...(sticky
          ? {
              position: { xs: 'sticky', md: 'static' },
              top: stickyTop,
              zIndex: (t) => t.zIndex.appBar - 2,
              bgcolor: (t) => t.palette.background.default,
              pt: { xs: 0.75, md: 0 },
              pb: { xs: 1, md: 0 },
              mx: { xs: -0.5, md: 0 },
              px: { xs: 0.5, md: 0 },
            }
          : null),
      }}
    >
      <PhotosSegmentedControl
        value={value}
        onChange={onChange}
        options={options}
        size={size}
        accentColor={accentColor}
        fullWidth
      />
    </Box>
  );
}

export const ADMIN_GALLERY_FILTER_STICKY_TOP = { xs: 172, sm: 180 };

export default MPhotoSectionTabs;
